<script lang="ts">
    import type { FreeProductRewardEntity } from "@apps/rewards/entities/entities";
    import type ProductEntity from "@modules/products/entities/ProductEntity";

    import ProductContainer from "@components/ProductContainer.svelte";

    interface $$Slots {
        default: {
            reward: {
                reward: FreeProductRewardEntity;
                product: ProductEntity;
                variant: ProductEntity["variants"][number];
            };
        };
    }

    export let reward: FreeProductRewardEntity;
</script>

<ProductContainer
    let:productInfo={{ product, variant }}
    productId={reward.productId}
    variantId={reward.variants[0].id}
>
    {#if product && variant}
        <slot reward={{ reward, product, variant }} />
    {/if}
</ProductContainer>
